import React, { useEffect, useState } from 'react'
import BackButton from './../Components/backButton'
import boy from '../Resources/img/boy-profile.png'
import girl from '../Resources/img/girl-profile.png'
import { DualRing } from 'react-loading-io'
import { useForm } from 'react-hook-form'
import WapperInvestmentProfile from '../Components/wapperInvestmentProfile'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { API } from 'aws-amplify'
import RightPerson from '../Components/rightPerson'
import { useDispatch } from 'react-redux'
import { addRecommended } from '../Store/recommended/actions'
import { getConvertAssured,getConvertContratant } from '../Utils/utils'
import { addIdProspecto } from './../Store/prospect/actions'

const InvestmentProfile = () => {
    const history = useHistory()
    const updatedData = useSelector((state) => state.data)
    const assuredValues =
        Object.values(updatedData) && Object.values(updatedData)[0]
    const contratantValues =
        Object.values(updatedData).length > 1 && Object.values(updatedData)[1]
    const [gender, setGender] = useState(girl)
    const [name, setName] = useState('')
    const [age, setAge] = useState('')
    const [loading, setLoading] = useState(false)
    const [profile, setProfile] = useState('asegurado')
    const dispatch = useDispatch()
    const { assured, contratant } = updatedData
    const {
        handleSubmit,
        register,
        errors,
        getValues,
        setError,
        clearError,
        setValue,
    } = useForm()

    const callOnSubmit = async (data) => {
        let preguntasRespuestas = []

        Object.entries(data).forEach((objEntry) => {
            preguntasRespuestas.push({
                pregunta: objEntry[0],
                respuesta: objEntry[1],
            })
        })
        let asegurado = Object.values(assured).length > 1 ? getConvertAssured(assured) : {}
        let contratante =  Object.values(contratant).length > 1 ?  getConvertContratant(contratant) : {}
        const payload = {
            canalOrigen: 'JOURNEY_INVERSION',
            preguntasRespuestas,
            asegurado,
            contratante
        }

        const myInit = {
            body: payload,
            headers: {},
        }

        try {
            setLoading(true)

            await API.post(
                'api-rentas',
                '/perfilamiento/actualizarProspecto',
                myInit
            )
                .then((response) => {
                    if (response.payload.idProspecto) {
                        dispatch(addIdProspecto(response.payload.idProspecto));
                    }
                    dispatch(
                        addRecommended({
                            product: response.payload.resultadoPerfilamiento.producto,
                            investmentProfile: response.payload.resultadoPerfilamiento.perfil,
                        })
                    )
                    history.push('/productos')
                })
                .catch((error) => {
                    console.log('Error: ', error)
                })
        } catch (ex) {
            console.log(ex)
        }
        setLoading(false)
    }

    const onSubmit = (values) => {
        const data = {
            ...values,
        }
        callOnSubmit(data)
    }

    useEffect(() => {
        if (
            assured !== undefined &&
            contratant !== undefined &&
            Object.keys(contratant).length > 0 &&
            Object.keys(assured).length > 0 &&
            assured !== contratant
        ) {
            setProfile('contratante')
        } else if (
            assured !== undefined &&
            Object.keys(assured).length > 0 &&
            (contratant === undefined || Object.keys(contratant).length === 0)
        ) {
            setProfile('asegurado')
        }
    }, [assured, contratant])

    useEffect(() => {
        if (Object.values(updatedData)) {
            if (
                assuredValues &&
                assuredValues.sexo === 'F' &&
                !contratantValues
            ) {
                setGender(girl)
                setName(assuredValues.names)
                setAge(assuredValues.birthday)
            } else if (
                assuredValues &&
                assuredValues.sexo === 'M' &&
                !contratantValues
            ) {
                setGender(boy)
                setName(assuredValues.names)
                setAge(assuredValues.birthday)
            } else if (contratantValues && contratantValues.sexo === 'F') {
                setGender(girl)
                setName(contratantValues.names)
                setAge(contratantValues.birthday)
            } else if (contratantValues && contratantValues.sexo === 'M') {
                setGender(boy)
                setName(contratantValues.names)
                setAge(contratantValues.birthday)
            }
        }
    }, [updatedData, assuredValues, contratantValues])

    return (
        <>
            <div className="adForm-container">
                <div className="adForm adForm--b  adForm--c product-ig">
                    <div className="adForm__container-titles">
                        <BackButton />
                        <h2 className="adForm__container-titles__title">
                            Perfil de{' '}
                            <span className="redtitle">inversión</span>
                        </h2>
                        <p className="adForm__container-titles__sub-title">
                            Conoce el perfil de inversión del <b>{profile}</b>
                        </p>
                        <p className="adForm__container-titles__sub-title">
                            Completa este formulario con las respuestas que te
                            brinde <b>{name.split(' ')[0]}</b>, te ayudará a
                            conocer que producto ofrecerle.
                        </p>
                    </div>
                    <form
                        onSubmit={handleSubmit(onSubmit)}
                        className="adForm__form"
                    >
                        <WapperInvestmentProfile
                            getValues={getValues}
                            errors={errors}
                            setLoading={setLoading}
                            setError={setError}
                            clearError={clearError}
                            setValue={setValue}
                            register={register}
                        />

                        <div className="adForm__form__btnew-group align-btn">
                            <button
                                id="button_quote_vas"
                                type="submit"
                                className="btnew"
                            >
                                CONTINUAR
                            </button>
                        </div>
                    </form>
                    {loading && (
                        <div className="loading-field">
                            <DualRing size={50} />
                        </div>
                    )}
                </div>
                <RightPerson image={gender} name={name} birthday={age} />
            </div>
            {loading && (
                <div className="loading-field">
                    <DualRing size={50} />
                </div>
            )}
        </>
    )
}

export default InvestmentProfile
